import { Component } from '@angular/core';
import { ShadowQueryDateProperty } from '../../../shared/services/device-shadow/device-shadow.service';
import {
  FilterType,
  QueryOptions,
  ValueType,
} from '../../query-builder/query-builder.component';
import { ShadowPageBaseComponent } from '../shadow-page-base.component';

@Component({
  selector: 'dcc-overdue-insights',
  templateUrl: '../shadow-page-base.component.html',
  styleUrls: ['../shadow-page-base.component.scss'],
})
export class OverdueInsightsComponent extends ShadowPageBaseComponent {
  override queryOptions: QueryOptions = {
    name: 'Overdue for Download',
    description: 'No Device Check-in within four days.',
    baseFilters: [
      {
        propertyName: ShadowQueryDateProperty.checkIn,
        value: this.getDaysAgoValue(4),
        filterType: FilterType.RangeEnd,
        valueType: ValueType.Date,
      },
    ],
  };

  private getDaysAgoValue(days: number) {
    return new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
  }
}
